import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { Fragment } from 'react';
import memoizeOne from 'memoize-one';
import { getNodeRenderer } from '@atlaskit/editor-common/extensions';
import { WithProviders } from '@atlaskit/editor-common/provider-factory';
import { getExtensionRenderer } from '@atlaskit/editor-common/utils';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
const inlineExtensionStyle = css({
  display: 'inline-block',
  maxWidth: '100%',
  verticalAlign: 'middle',
  // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
  '& .rich-media-item': {
    maxWidth: '100%'
  }
});
export default class ExtensionRenderer extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      extensionProvider: null
    });
    _defineProperty(this, "mounted", false);
    _defineProperty(this, "handleProvider", (name, providerPromise) => {
      providerPromise && providerPromise.then(provider => {
        if (this.mounted) {
          this.setState({
            [name]: provider
          });
        }
      });
    });
    _defineProperty(this, "getNodeRenderer", memoizeOne(getNodeRenderer));
    _defineProperty(this, "renderExtensionNode", extensionProvider => {
      var _marks$find, _marks$find$attrs;
      const {
        extensionHandlers,
        rendererContext,
        extensionType,
        extensionKey,
        parameters,
        content,
        text,
        type,
        localId,
        marks,
        actions
      } = this.props;
      const fragmentLocalId = marks === null || marks === void 0 ? void 0 : (_marks$find = marks.find(m => m.type.name === 'fragment')) === null || _marks$find === void 0 ? void 0 : (_marks$find$attrs = _marks$find.attrs) === null || _marks$find$attrs === void 0 ? void 0 : _marks$find$attrs.localId;
      const node = {
        type,
        extensionKey,
        extensionType,
        parameters,
        content: content || text,
        localId,
        fragmentLocalId
      };
      let result = null;
      try {
        if (extensionHandlers && extensionHandlers[extensionType]) {
          const render = getExtensionRenderer(extensionHandlers[extensionType]);
          result = render(node, rendererContext.adDoc);
        }
        if (!result && extensionProvider) {
          const NodeRenderer = this.getNodeRenderer(extensionProvider, extensionType, extensionKey);
          if (node.type === 'multiBodiedExtension') {
            result = jsx(NodeRenderer, {
              node: node,
              actions: actions
            });
          } else if (node.type === 'inlineExtension') {
            result = jsx(InlineNodeRendererWrapper, null, jsx(NodeRenderer, {
              node: node
            }));
          } else {
            result = jsx(NodeRenderer, {
              node: node
            });
          }
        }
      } catch (e) {
        /** We don't want this error to block renderer */
        /** We keep rendering the default content */
      }
      return this.props.children({
        result
      });
    });
    _defineProperty(this, "setupAndRenderExtensionNode", providers => {
      const {
        extensionProvider
      } = this.state;
      if (!extensionProvider && providers.extensionProvider) {
        this.handleProvider('extensionProvider', providers.extensionProvider);
      }
      return this.renderExtensionNode(extensionProvider);
    });
  }
  UNSAFE_componentWillMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      providers
    } = this.props;
    if (!providers) {
      return this.setupAndRenderExtensionNode({});
    }
    return jsx(WithProviders, {
      providers: ['extensionProvider'],
      providerFactory: providers,
      renderNode: this.setupAndRenderExtensionNode
    });
  }
}
const InlineNodeRendererWrapper = ({
  children
}) => {
  if (getBooleanFF('platform.editor.inline_extension.extended_lcqdn')) {
    return jsx("div", {
      className: "inline-extension-renderer",
      css: inlineExtensionStyle
    }, children);
  }
  return jsx(Fragment, null, children);
};